import { Injectable } from '@angular/core';
import { CookieService } from '@gorniv/ngx-universal';
import { BehaviorSubject, Observable } from 'rxjs';
import { MemberAccess } from '../models/common/member-access.model';
import { User } from '../models/vet-users/user.model';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly localStorageSubject$ = new BehaviorSubject<{
    [key: string]: any;
  }>({});

  public constructor(
    private readonly cookieService: CookieService,
    private readonly encryptionService: EncryptionService
  ) {
    this.localStorageSubject$.next(localStorage);
  }

  public clear(): void {
    localStorage.clear();
  }

  public getItem(key: string): string | null {
    return this.encryptionService.decryptAES(localStorage.getItem(key));
  }

  public removeItem(key: string): void {
    delete localStorage[key];
  }

  public setItem(key: string, value: string): void {
    localStorage.setItem(key, this.encryptionService.encryptAES(value));
  }

  public get localStorage$(): Observable<{}> {
    return this.localStorageSubject$.asObservable();
  }

  public get GetUser(): User {
    const userString = this.getItem('User');
    const user = JSON.parse(this.encryptionService.decryptAES(userString));
    return user;
  }

  public get GlobalMemberAccessData(): MemberAccess {
    let globalMemberAccessString: string = this.getItem(
      'GlobalMemberAccessData'
    );
    if (
      globalMemberAccessString === null ||
      typeof globalMemberAccessString === 'undefined'
    ) {
      return {
        isSalesEditor: false,
        isSubmitAccess: false,
        isAllSaleAccess: false,
        isViewOnly: false,
        isSaleFeatureEnabled: true,
        isViewXraysAllowed: false,
        isLocalStorageEnabled: false,
        validationMessage: '',
      };
    }
    try {
      let memberAccess: MemberAccess = JSON.parse(
        this.encryptionService.decryptAES(globalMemberAccessString)
      );
      if (memberAccess.isSaleFeatureEnabled) {
        memberAccess.isSaleFeatureEnabled = true; // assigning default value for previoulsy stored values for the users that are already logged in
      }
      return memberAccess;
    } catch (e) {
      return {
        isSalesEditor: false,
        isSubmitAccess: false,
        isAllSaleAccess:false,
        isViewOnly: false,
        isSaleFeatureEnabled: true,
        isViewXraysAllowed: false,
        isLocalStorageEnabled: false,
        validationMessage: '',
      };
    }
  }

  public set GlobalMemberAccessData(memberAccessData: MemberAccess) {
    this.setItem(
      'GlobalMemberAccessData',
      this.encryptionService.encryptAES(JSON.stringify(memberAccessData))
    );
  }

  public getSaleMmeberAccessData(saleId: number): MemberAccess {
    let accessDataString: string = this.getItem(
      `MemberSaleAccessData_${saleId}`
    );
    if (accessDataString === null || typeof accessDataString === 'undefined') {
      return null;
    }
    try {
      return JSON.parse(this.encryptionService.decryptAES(accessDataString));
    } catch (e) {
      return null;
    }
  }

  public setSaleMemberAccessData(
    saleId: number,
    memberAccessData: MemberAccess
  ) {
    this.setItem(
      `MemberSaleAccessData_${saleId}`,
      this.encryptionService.encryptAES(JSON.stringify(memberAccessData))
    );
  }
}
